// Email Validation Utilities

/**
 * Validates email format using a comprehensive regex pattern
 * @param {string} email - The email to validate
 * @returns {boolean} - True if valid email format
 */
export const isValidEmail = (email) => {
  if (!email || typeof email !== 'string') {
    return false;
  }

  // Comprehensive email regex pattern
  // Allows most valid email formats including international domains
  const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  
  return emailPattern.test(email.trim());
};

/**
 * Gets email validation error message
 * @param {string} email - The email to validate
 * @returns {string|null} - Error message or null if valid
 */
export const getEmailValidationError = (email) => {
  if (!email || email.trim() === '') {
    return null; // Empty is allowed (optional field)
  }

  if (!isValidEmail(email)) {
    return 'Invalid email address';
  }

  return null;
};

/**
 * Formats email by trimming whitespace and converting to lowercase
 * @param {string} email - The email to format
 * @returns {string} - Formatted email
 */
export const formatEmail = (email) => {
  if (!email || typeof email !== 'string') {
    return email;
  }

  return email.trim().toLowerCase();
};

export default {
  isValidEmail,
  getEmailValidationError,
  formatEmail
};
